import styled from 'styled-components';

export const EditCellContent = styled.div.attrs<{ className?: string }>({
  className: 'table-cell-content md:min-h-[88px]',
})`
  margin: 0;

  .permissions-head {
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    padding: 0 0 22px;
  }

  .permissions-list {
    display: flex;
    align-items: center;
    gap: 30px;

    .permission {
      display: flex;
      gap: 10px;
      align-items: center;

      .label {
        color: var(--color-text-muted);
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 12px */
      }
    }
  }
`;
